import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Blogs.css';

function Blogs() {
    const [posts, setPosts] = useState([]);
    const [activeCategory, setActiveCategory] = useState('notice');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();

    const categories = {
        notice: 6,
        blogs: 7,
    };

    useEffect(() => {
        const categoryId = categories[activeCategory];
        fetch(`https://www.limshmi.com/lims-blogs/wp-json/wp/v2/posts?categories=${categoryId}&_embed&per_page=10&page=${currentPage}`)
            .then(res => {
                if (res.headers.get('X-WP-TotalPages')) {
                    setTotalPages(parseInt(res.headers.get('X-WP-TotalPages'), 10));
                }
                return res.json();
            })
            .then(data => setPosts(data))
            .catch(err => console.error(err));
    }, [activeCategory, currentPage]);

    const handlePageChange = (direction) => {
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        } else if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleBlogClick = (id) => {
        navigate(`/blog/${id}`);
    };

    return (
        <>
            <div className="blogs-outer">
                <div className="blogs-inner">
                    <h2 className="header-text">Blogs</h2>
                    <p className='letter-text'>
                        Welcome to our blog section! Here, we share insights, updates, and stories related to our community and activities.
                    </p>
                </div>
            </div>

            <div className="blogs-main w-100 d-flex flex-column justify-content-start align-items-center">
                {/* Category Buttons */}
                <div className="blogs-categories w-100 d-flex flex-row justify-content-start align-items-center">
                    {Object.keys(categories).map(key => (
                        <div className="blogs-category" key={key}>
                            <button onClick={() => { setActiveCategory(key); setCurrentPage(1); }} className={activeCategory === key ? 'active' : ''}>
                                {key.charAt(0).toUpperCase() + key.slice(1)}
                            </button>
                        </div>
                    ))}
                </div>

                {/* Blog Details */}
                {posts.length === 0 ? (
                    <p style={{ marginTop: '20px' }}>No posts found in this category.</p>
                ) : (
                    posts.map(post => (
                        <div
                            className="blogs-details w-100 d-flex flex-row justify-content-center align-items-start"
                            key={post.id}
                            onClick={() => handleBlogClick(post.id)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="blog-image w-25">
                                <img
                                    src={
                                        post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '/default.jpg'
                                    }
                                    alt={post.title.rendered}
                                    loading="lazy"
                                />
                            </div>
                            <div className="blog-description w-75 d-flex flex-column justify-content-start align-items-start">
                                <p className="blog-category cta-text">{activeCategory.toUpperCase()}</p>
                                <p className="blog-title secondary-header">{post.title.rendered}</p>
                                <p className="blog-meta letter-text" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered.slice(0, 160) }} />
                            </div>
                        </div>
                    ))
                )}

                {/* Pagination */}
                <div className="pagination w-100 d-flex justify-content-center align-items-center">
                    <button onClick={() => handlePageChange('prev')} disabled={currentPage === 1}>
                        Previous
                    </button>
                    <span>{currentPage} of {totalPages}</span>
                    <button onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>
        </>
    );
}

export default Blogs;
